Plyr = require('plyr')
# remove call to noembedd.com
Plyr.defaults.urls.youtube.api = ''
window.PlyrPresets =
  default: ->
    controls: ['play-large', 'play', 'progress', 'volume', 'mute', 'fullscreen']
    youtube:
      rel: 0
      modestbranding: 1